var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-select',_vm._g({attrs:{"value":_vm.value,"clearable":true}},_vm.$listeners),_vm._l((_vm.sources),function(label,key){return _c('i-option',{key:key,attrs:{"value":key,"label":label}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }